import React from "react";
import { Skeleton } from "antd";

type RouteLoadingFallbackProps = {
  /** Inside main layout (after header/sidebar); mirrors page-wrapper pages */
  variant?: "embedded" | "fullscreen";
};

export const RouteLoadingFallback: React.FC<RouteLoadingFallbackProps> = ({
  variant = "embedded",
}) => {
  if (variant === "fullscreen") {
    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          boxSizing: "border-box",
        }}
      >
        <div style={{ width: "100%", maxWidth: 480 }}>
          <Skeleton active paragraph={{ rows: 8 }} />
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="content content-two">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="w-100" style={{ maxWidth: 400 }}>
            <Skeleton active title={{ width: 200 }} paragraph={{ rows: 1, width: "100%" }} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card mb-3">
              <div className="card-header bg-light py-3">
                <Skeleton.Input active size="small" style={{ width: 200 }} />
              </div>
              <div className="card-body">
                <Skeleton active paragraph={{ rows: 10 }} />
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <Skeleton active paragraph={{ rows: 6 }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
